export const parseContractDate = (value: string | null): Date | null => {
  if (!value) return null
  const date = new Date(value)
  return isNaN(date.getTime()) ? null : date
}

// The API sends a sentence such as "Non signé" instead of a date when the step hasn't happened yet.
export const formatContractDate = (value: string | null, separator: string): string => {
  if (!value) return '-'
  const date = parseContractDate(value)
  if (!date) return String(value)
  return `${date.toLocaleDateString('fr-FR')}${separator}${date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
}
